import PropTypes from 'prop-types';
import { useState } from 'react';
import BookingItemTitle from '../components/CruiseBooking/BookingItemTitle';

const TwExpansionPanel = ({ isExpandable, headerText, byline, children, defaultIsExpandable }) => {
  const [expanded, setExpanded] = useState(defaultIsExpandable);
  const handleExpandMoreClick = () => {
    setExpanded((v) => !v);
  };

  return (
    <div className="border border-gray-300 bg-white shadow rounded-md w-full mx-auto mb-5">
      {headerText && (
        <BookingItemTitle
          placeholder={headerText}
          byline={byline}
          doShowExpandMore={expanded}
          onClickExpand={isExpandable ? handleExpandMoreClick : undefined}
        />
      )}
      {(!isExpandable || expanded) && children}
    </div>
  );
};

TwExpansionPanel.propTypes = {
  headerText: PropTypes.string,
  byline: PropTypes.string,
  isExpandable: PropTypes.bool,
  defaultIsExpandable: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.arrayOf(PropTypes.any),
  ]).isRequired,
};

TwExpansionPanel.defaultProps = {
  headerText: undefined,
  isExpandable: false,
  defaultIsExpandable: true,
  byline: '',
};

export default TwExpansionPanel;
